module.exports = __webpack_public_path__ + "static/017.thumb-6722686c0354371fcd71f45d0249ae63.jpg";